import React from "react";

interface FooterProps {
  //
}

const Footer: React.FC<FooterProps> = () => {
  return (
    <div>
      {" "}
      <footer className="footer text-center">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-5 mb-lg-0">
              <h4 className="text-uppercase mb-4">Find me around the Web</h4>
              <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <a
                    className="btn btn-outline-light btn-social text-center rounded-circle"
                    href="https://www.github.com/hillkim"
                  >
                    <i className="fab fa-fw fa-github"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="btn btn-outline-light btn-social text-center rounded-circle"
                    href="https://stackoverflow.com/users/8892202/hillkim-henry"
                  >
                    <i className="fab fa-fw fa-stack-overflow"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="btn btn-outline-light btn-social text-center rounded-circle"
                    href="https://www.twitter.com/hillkimh"
                  >
                    <i className="fab fa-fw fa-twitter"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="btn btn-outline-light btn-social text-center rounded-circle"
                    href="https://www.linkedin.com/in/hillary-kimaita-28635b100/"
                  >
                    <i className="fab fa-fw fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://dev.to/hillkim"
                    className="btn btn-outline-light btn-social text-center rounded-circle"
                  >
                    <i className="fab fa-dev" title="hillkim's DEV Profile"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright py-4 text-center text-white">
        <div className="container">
          <small>
            Made with ❤️ by Hillary Kimaita <br />
            &copy; {new Date().getFullYear()}
          </small>
        </div>
      </div>
      <div className="scroll-to-top d-lg-none position-fixed ">
        <a
          className="js-scroll-trigger d-block text-center text-white rounded"
          href="#page-top"
        >
          <i className="fa fa-chevron-up"></i>
        </a>
      </div>
    </div>
  );
};

export default Footer;
